'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fbIcon = require('./icons/fb-icon.png.js');
var googleIcon = require('./icons/google-icon.png.js');

// eslint-disable-next-line import/prefer-default-export
var getIconFrom = function (type) {
    if (type === 'facebook') {
        return fbIcon;
    }
    if (type === 'google') {
        return googleIcon;
    }
    return '';
};

exports.getIconFrom = getIconFrom;
